import { generateRandomEntities } from './generateResources';

const getChildren = (skip: number) => {
  switch (skip) {
    case 0:
      return generateRandomEntities(50);

    case 50:
      return generateRandomEntities(50);

    case 100:
      return generateRandomEntities(50);

    case 150:
      return generateRandomEntities(50);

    case 200:
      return generateRandomEntities(40);

    default:
      return [];
  }
};

export default (skip: number) => ({
  Entities: [...getChildren(skip)],
  Links: [
    {
      Href: 'https://uat.timelog.com/rp-test1/api/v2/resource-planner/employee-search',
      Rel: 'self',
    },
  ],
});
